if (!customElements.get('cart-cross-sell')) {
  class CartCrossSell extends HTMLElement {
    connectedCallback() {
      const productId = this.dataset.productId;
      const currency = this.dataset.currency || 'EUR';

      // Always wire up "+ Añadir" clicks, even when there's no productId to
      // fetch recommendations for — the empty-cart state renders its own
      // static list (bestsellers) server-side and relies on this same
      // handler for its add-to-cart buttons.
      this.addEventListener('click', this.handleClick.bind(this));

      if (!productId) return;

      fetch(`/recommendations/products.json?product_id=${productId}&limit=3`)
        .then((response) => response.json())
        .then((data) => {
          const products = data.products || [];
          if (!products.length) {
            this.remove();
            return;
          }

          const list = this.querySelector('.cart-cross-sell__list');
          list.innerHTML = products.map((product) => this.renderCard(product, currency)).join('');
        })
        .catch(() => this.remove());
    }

    renderCard(product, currency) {
      const formatMoney = (cents) =>
        (cents / 100).toLocaleString('es-ES', {
          style: 'currency',
          currency,
        });
      const price = formatMoney(product.price);
      const title = this.escapeHtml(product.title);
      const image = product.featured_image
        ? `<img src="${product.featured_image}" alt="${title}" loading="lazy" width="120" height="120">`
        : '';
      const availableVariant = (product.variants || []).find((variant) => variant.available);

      const button = availableVariant
        ? `<button type="button" class="cart-cross-sell__add" data-variant-id="${availableVariant.id}">+ Añadir</button>`
        : `<button type="button" class="cart-cross-sell__add" disabled>Agotado</button>`;

      const onSale = product.compare_at_price > product.price;
      const compareMarkup = onSale
        ? `<s class="cart-cross-sell__price--compare">${formatMoney(product.compare_at_price)}</s>`
        : '';
      const savingsMarkup = onSale
        ? `<p class="cart-cross-sell__savings">Ahorrarás ${formatMoney(product.compare_at_price - product.price)}</p>`
        : '';

      const li = document.createElement('li');
      li.className = 'cart-cross-sell__item';
      li.innerHTML =
        `<a href="${product.url}" class="cart-cross-sell__card">` +
        `<div class="cart-cross-sell__media">${image}</div>` +
        `<p class="cart-cross-sell__title">${title}</p>` +
        `<p class="cart-cross-sell__price">${compareMarkup} ${price}</p>` +
        savingsMarkup +
        `</a>` +
        button;
      return li.outerHTML;
    }

    handleClick(event) {
      const button = event.target.closest('.cart-cross-sell__add');
      if (!button || button.disabled) return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const originalLabel = button.textContent;
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'Añadiendo…';

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Failed to add product to cart');
          return fetch(window.routes.cart_url + '.js');
        })
        .then((response) => response.json())
        .then((cart) => {
          // Adding from the empty-cart state (this element's only route in
          // that case) transitions cart-drawer out of "empty" — the generic
          // cartUpdate event below only refreshes cart-drawer-items and the
          // footer, it doesn't touch this class (only the quantity +/-
          // handlers in cart.js do that), so it's set here explicitly.
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', cart.item_count === 0);

          // Same reason: the checkout button (form="CartDrawer-Form") and the
          // header cart icon both live outside the cart-drawer-items /
          // .cart-drawer__footer scope that the generic cartUpdate refresh
          // covers, so they're never reached by it. That's never mattered
          // for the other things that publish cartUpdate (gift
          // auto-add/remove, quantity changes) because none of them can fire
          // while the cart is empty — this button is the only one that can,
          // so it's the only place these need refreshing by hand.
          const checkoutButton = document.getElementById('CartDrawer-Checkout');
          if (checkoutButton) checkoutButton.disabled = cart.item_count === 0;

          fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const source = html.querySelector('.shopify-section');
              const destination = document.getElementById('cart-icon-bubble');
              if (source && destination) destination.innerHTML = source.innerHTML;
            })
            .catch(() => {});

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-cross-sell', cartData: cart });
          }
        })
        .catch((error) => {
          console.error('cart-cross-sell: failed to add product', error);
          button.disabled = false;
          button.classList.remove('is-loading');
          button.textContent = originalLabel;
        });
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }

  customElements.define('cart-cross-sell', CartCrossSell);
}
